export const EVIDENCE_FIELD_DEVICE_PROPERTIES = ['evidenceField', 'evidenceFieldInsertOnly'] as const;

/**
 * Checks whether a mapped device property targets an evidence field.
 */
export function isEvidenceFieldDeviceProperty(property?: string): boolean {
  return (
    !!property &&
    EVIDENCE_FIELD_DEVICE_PROPERTIES.includes(property as (typeof EVIDENCE_FIELD_DEVICE_PROPERTIES)[number])
  );
}
